import React from "react";
import { slide as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import { MY_INFO_URL } from "../../../../utils/config/Config";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  redirectURL,
  Service_CN,
  Service_GL
} from "../../../../utils/CommonFunc";
import Language from "../../language/Language";
import LnbPromo from "../LnbPromo";
import { useTranslation, withTranslation } from "react-i18next";
import LoginBtn from "../common/LoginBtn";
import SideMenuList from "./SideMenuList";
import Grade from "../common/Grade";
import {
  isLoginStateSelector,
  userIdState,
  userNicknameState
} from "../../../../recoil/userInfoAtom";
import { sideMenuToggleState } from "../../../../recoil/commonUiAtom";

interface IProps {
  logout: () => void;
}

function SideMenu(props: IProps) {
  const { t } = useTranslation();
  const { logout } = props;
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const userId = useRecoilValue(userIdState);
  const userNickname = useRecoilValue(userNicknameState);
  const [openSideMenu, setOpenSideMenu] = useRecoilState(sideMenuToggleState);

  const onClickSideMenu = () => {
    setOpenSideMenu((openSideMenu) => !openSideMenu);
  };

  return (
    <Menu
      pageWrapId={"page-wrap"}
      outerContainerId={"combineMenu"}
      customBurgerIcon={false}
      isOpen={openSideMenu}
      onClose={() => {
        onClickSideMenu();
      }}
    >
      <div id="cbm-aside">
        <div className="side-menu">
          {/*<!-- sideMenu 상단 로고와 x -->*/}
          <h1 className="tit-service">
            <Link
              to="#"
              className={`cbm-logo ${Service_CN ? "cn" : ""}`}
              onClick={(e) =>
                redirectURL(
                  process.env.REACT_APP_PLATFORM_DNS ||
                    "https://vfun.valofe.com",
                  "_self",
                  isLoginState.isLauncher
                )
              }
            />
            <Link
              to="#"
              className="btn-cbm-close"
              onClick={() => setOpenSideMenu(() => false)}
            />
          </h1>

          {/* 회원 정보 + 다국어 */}
          {!isLoginState.isLogIn ? (
            // 로그인 전
            <div className="user-info not-login clearfix">
              <LoginBtn type="side" addclassname="clearfix" />
            </div>
          ) : (
            // 로그인 후
            <div className="user-info login clearfix">
              <span className="user-name">
                {t("welcome")}
                <Link to="#" className="info" title={t("my_info")}>
                  {Service_GL && !Service_CN ? <Grade /> : null}
                  <span
                    className="color-theme pull-right"
                    onClick={MY_INFO_URL}
                  >
                    {userNickname === "" ? userId : userNickname}
                  </span>
                </Link>
              </span>
              <ul className="pull-right clearfix">
                <li>
                  <Link to="#" onClick={MY_INFO_URL}>
                    {t("my_info")}
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={() => logout()}>
                    {t("signout")}
                  </Link>
                </li>

                {Service_GL && !Service_CN ? (
                  <li>
                    <Language />
                  </li>
                ) : null}
              </ul>
            </div>
          )}

          {/* sideMenus 카테고리 */}
          <SideMenuList />
          <LnbPromo />
        </div>
      </div>
    </Menu>
  );
}

export default React.memo(withTranslation()(SideMenu));
